import template from './parking.jade';
import allItems, {itemsByCategory} from "../../../enums/parking-type";
import {filterItemsWithOrder} from "../../filter-items";

export default angular
    .module('cian.addForm.aboutObjectParking', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectParking', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            const categoryConfig = itemsByCategory.default;
            this.items = filterItemsWithOrder(allItems, 'key', categoryConfig.items);
        },
        controllerAs: 'parking',
        template,
    }))
    .name;
